// Shezair Inbox Brand Style
(function() {
  var STYLE_ID = "shezair-inbox-brand-style-shadow-v2";
  var MAX_TRIES = 120;
  var tries = 0;

  function patchContainer() {
    var container = document.getElementById("chat-button-container");
    if (!container) return;
    container.setAttribute("data-color", "#FFFFFF");
    container.setAttribute("data-secondary-color", "#FFFFFF");
    container.setAttribute("data-ternary-color", "#111111");
  }

  function applyStyle() {
    patchContainer();

    var host = document.getElementById("ShopifyChat");
    if (!host || !host.shadowRoot) return false;

    var isOpen = host.getAttribute("is-open") === "true" || !!host.shadowRoot.querySelector('[aria-expanded="true"]');

    host.style.right = "20px";
    host.style.bottom = isOpen ? "88px" : "20px";
    host.style.height = isOpen ? "min(640px, calc(100vh - 126px))" : "56px";
    host.style.maxHeight = "calc(100vh - 112px)";
    host.style.zIndex = "2147483647";
    host.style.overflow = "visible";

    if (!host.shadowRoot.getElementById(STYLE_ID)) {
      var style = document.createElement("style");
      style.id = STYLE_ID;
      style.textContent = ':host{right:20px!important;bottom:20px!important;height:56px!important;max-height:calc(100vh - 112px)!important;overflow:visible!important;font-family:Inter,"Helvetica Neue",Arial,sans-serif!important}:host([is-open="true"]){bottom:88px!important;height:min(640px,calc(100vh - 126px))!important}.chat-app{max-height:calc(100vh - 112px)!important;overflow:visible!important;background:transparent!important;border:0!important;box-shadow:none!important}:host([is-open="true"]) .chat-app{background:#ffffff!important;border:1px solid rgba(17,17,17,.14)!important;box-shadow:0 18px 48px rgba(0,0,0,.14),0 4px 14px rgba(0,0,0,.08)!important}.chat-app>:not(.chat-toggle),[class*=chat-window],[class*=conversation],[class*=message-list],[data-spec*=chat-window],[data-spec*=conversation]{max-height:calc(100vh - 126px)!important;overflow:auto!important}.chat-toggle{min-height:52px!important;height:52px!important;padding:0 18px 0 15px!important;gap:8px!important;border-radius:999px!important;border:1px solid rgba(17,17,17,.28)!important;background:#ffffff!important;color:#111111!important;box-shadow:0 12px 28px rgba(0,0,0,.12),0 2px 8px rgba(0,0,0,.08)!important;backdrop-filter:blur(10px)!important;-webkit-backdrop-filter:blur(10px)!important;transition:transform 220ms ease,box-shadow 220ms ease,border-color 220ms ease,background 220ms ease!important}.chat-toggle:hover,.chat-toggle:focus-visible{transform:translateY(-2px)!important;border-color:rgba(17,17,17,.55)!important;background:#ffffff!important;box-shadow:0 16px 34px rgba(0,0,0,.16),0 3px 10px rgba(0,0,0,.1)!important}:host([is-open="true"]) .chat-toggle{transform:none!important}.chat-toggle svg{width:19px!important;height:19px!important}.chat-toggle svg path{fill:#111111!important}.chat-title{color:#111111!important;font-size:11px!important;line-height:1!important;font-weight:500!important;letter-spacing:1.45px!important;text-transform:uppercase!important}.chat-notification{background:#111111!important;color:#ffffff!important;border:2px solid #ffffff!important;box-shadow:0 4px 12px rgba(0,0,0,.16)!important}.chat-app,.chat-app *{color:#111111!important}:host([is-open="true"]) .chat-app{background:#ffffff!important;border:1px solid rgba(17,17,17,.14)!important;box-shadow:0 18px 48px rgba(0,0,0,.14),0 4px 14px rgba(0,0,0,.08)!important}.chat-app input,.chat-app textarea{background:#ffffff!important;color:#111111!important;border:1px solid rgba(17,17,17,.28)!important}.chat-app input::placeholder,.chat-app textarea::placeholder{color:#777777!important}:host(:not([is-open="true"])) .chat-app{background:transparent!important;border:0!important;box-shadow:none!important}:host(:not([is-open="true"])) .chat-toggle{background:#ffffff!important;border:1px solid rgba(17,17,17,.28)!important;box-shadow:0 12px 28px rgba(0,0,0,.12),0 2px 8px rgba(0,0,0,.08)!important}@media (max-width:749px){:host{right:14px!important;bottom:14px!important;height:50px!important;max-height:calc(100vh - 88px)!important}:host([is-open="true"]){right:10px!important;left:10px!important;bottom:74px!important;width:auto!important;height:min(560px,calc(100vh - 96px))!important}.chat-toggle{min-height:48px!important;height:48px!important;padding:0 15px!important}.chat-title{font-size:10px!important;letter-spacing:1.2px!important}.chat-app>:not(.chat-toggle),[class*=chat-window],[class*=conversation],[class*=message-list],[data-spec*=chat-window],[data-spec*=conversation]{max-height:calc(100vh - 96px)!important}}';
      host.shadowRoot.appendChild(style);
    }

    var label = host.shadowRoot.querySelector('[data-spec="button-text"]');
    if (label) label.textContent = "Chat";
    return true;
  }

  function boot() {
    applyStyle();
    var timer = window.setInterval(function() {
      tries += 1;
      var done = applyStyle();
      if (done && tries > 8) window.clearInterval(timer);
      if (tries >= MAX_TRIES) window.clearInterval(timer);
    }, 250);

    if ("MutationObserver" in window) {
      var observer = new MutationObserver(function() {
        applyStyle();
      });
      observer.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ["is-open", "style", "class", "aria-expanded"] });
      window.setTimeout(function() { observer.disconnect(); }, 60000);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();

/* Shezair wheel cache alignment fallback */
(function(){
  function patchWheel(){
    var modal=document.getElementById('shz-luck-modal');
    if(!modal) return;
    var wheel=modal.querySelector('.shz-wheel');
    var labels=modal.querySelectorAll('.shz-wheel-label');
    if(!wheel||labels.length<6) return;
    var text=['20% off','10% off','Free ship','15% off','Mystery','10% off'];
    var angles=['0deg','60deg','120deg','180deg','240deg','300deg'];
    labels.forEach(function(label,index){ label.textContent=text[index]; label.style.setProperty('--a',angles[index]); });
    if(!document.getElementById('shz-wheel-cache-fix-style')){
      var style=document.createElement('style');
      style.id='shz-wheel-cache-fix-style';
      style.textContent='.shz-wheel{background:repeating-conic-gradient(from -30deg,transparent 0deg 59.2deg,rgba(17,17,17,.16) 59.2deg 60deg),conic-gradient(from -30deg,#111 0deg 60deg,#f7f3ee 60deg 120deg,#fff 120deg 180deg,#f2ede7 180deg 240deg,#f7f3ee 240deg 300deg,#fff 300deg 360deg)!important}.shz-wheel-label{width:104px!important;margin-left:-52px!important;letter-spacing:.06em!important}.shz-wheel-label:nth-child(1),.shz-wheel-label:nth-child(4){color:#fff!important}.shz-wheel-label:nth-child(6){color:#111!important}';
      document.head.appendChild(style);
    }
    var btn=modal.querySelector('.shz-wheel-spin');
    if(btn&&!btn.dataset.shzWheelCacheFixed){
      btn.dataset.shzWheelCacheFixed='1';
      btn.addEventListener('click',function(){ setTimeout(function(){ wheel.style.transform='rotate(1440deg)'; },0); },true);
    }
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',patchWheel); else patchWheel();
  setTimeout(patchWheel,600);
  setTimeout(patchWheel,1800);
})();
/* End Shezair wheel cache alignment fallback */
(function(){
  function fixWheelContrast(){
    var modal=document.getElementById('shz-luck-modal');
    if(!modal) return;
    var labels=modal.querySelectorAll('.shz-wheel-label');
    labels.forEach(function(label,index){
      label.style.setProperty('color', index===0 ? '#ffffff' : '#111111', 'important');
      label.style.setProperty('text-shadow', index===0 ? 'none' : '0 1px 0 rgba(255,255,255,.62)', 'important');
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',fixWheelContrast); else fixWheelContrast();
  setTimeout(fixWheelContrast,500);
  setTimeout(fixWheelContrast,1800);
})();
/* shz-wheel-live-contrast-fix */